const MOBILE = 'MOBILE';
const DESKTOP = 'DESKTOP';

export default { MOBILE, DESKTOP };
